/**
 * /diary → /journal.
 *
 * These were two routes onto the same content: /journal renders FieldJournal
 * (Production + Diary tabs) and /diary rendered FarmDiary on its own. The
 * sidebar linked to /journal and the mobile bottom nav to /diary, so a farmer
 * on a phone could never reach the Production tab at all.
 *
 * A redirect rather than a deletion because /diary is bookmarkable and was the
 * mobile nav target for months. It carries the query string over: the map,
 * field list and zone popup deep-link as /journal?field=69&zone=187 and
 * FarmDiary reads those params to pre-filter, but React Router's <Navigate>
 * drops `search` unless it is passed explicitly.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const DiaryRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/journal${search}`} replace />;
};

export default DiaryRedirect;
